// SectionHeader.tsx

import { Box, Typography } from "@mui/material";

type Props = {
  title: string;
  count: number;
};

export const SectionHeader = ({
  title,
  count,
}: Props) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    mb={2}
  >
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 600,
        textTransform: "none",
      }}
    >
      {title}
    </Typography>

    <Typography
      variant="caption"
      color="text.secondary"
    >
      {count} registro{count !== 1 ? "s" : ""}
    </Typography>
  </Box>
);